module.exports = __webpack_public_path__ + "media/s-awc.1f6f3e04.mp4";